import { Directive, ElementRef, Output, EventEmitter, HostListener, OnInit } from '@angular/core';
import { fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[clickOutside]',
})
export class ClickOutsideDirective implements OnInit {
  @Output() clickOutside = new EventEmitter();

  captured = false;

  constructor(private elRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onClick(target) {
    // 🔥 Host element detached from DOM (being torn down/rebuilt by Angular
    // re-render). This is a stale listener from the old instance — ignore so it
    // can't report a real click as "outside" and close the panel mid-rebuild.
    if (!this.elRef.nativeElement?.isConnected) {
      return;
    }

    // 🔥 Clicked node was removed from the DOM by a re-render triggered on this
    // same click (e.g. selecting an item toggled an *ngIf/class and detached the
    // clicked node). Not a real outside click — keep the panel open.
    if (target instanceof Node && !document.contains(target)) {
      this.clickOutside.emit({ bol: true });
      return;
    }

    // 🔥 Ignore PrimeNG calendar popup
    const clickedCalendar = target.closest('.p-datepicker-header');
    const month = target.closest('.p-datepicker-month');
    const year = target.closest('.p-datepicker-year');
    const datepicker = target.closest('.p-datepicker');
    const link = target.closest('.p-link');
    const ripple = target.closest('.p-ripple');
    const ngDropdown = target.closest('.ng-dropdown-panel');

    if (this.elRef.nativeElement.contains(target) || ripple || clickedCalendar || month || year || link || datepicker || ngDropdown) {
      this.clickOutside.emit({ bol: true });
    } else {
      this.clickOutside.emit({ bol: false });
    }
  }

  ngOnInit() {
    fromEvent(document, 'click', { capture: true })
      .pipe(take(1))
      .subscribe(() => (this.captured = true));
  }
}
